<div class="app__mx--taskbar gap-4">
  @if(minimizedDialogs.length){ @for(dialog of minimizedDialogs; track dialog; let index = $index;){
  <div
    class="app__taskbar--cards"
    [style.width.px]="minimizedWidth"
    [style.maxWidth.px]="minimizedWidth"
    [ngClass]="{ 'bg-[#e7ffee] border-[#9edeb1]': dialog.status === 'completed', 'bg-white border-[#ccc]': dialog.status !== 'completed' }"
  >
    <div
      [ngStyle]="{ '--resizedWidth': minimizedWidth + 'px' }"
      class="app__text--overflow flex items-center justify-start w-[calc(var(--resizedWidth)-30px)]"
    >
      @if(dialog.status === 'completed'){
      <span class="mr-1"> <img src="assets/images/mx-connect-complete-icon.svg" alt="" /> </span>
      }
      <span class="app__form--attribute--title text-base whitespace-nowrap">{{ dialog.data?.institutionName }} {{ minimizedDialogs?.length }}</span>
    </div>
    <div class="flex items-center justify-end">
      <span class="hover:cursor-pointer" (click)="maximizeMxDialog(dialog)"> <img src="assets/images/mx-maximize-icon.svg" /> </span>
    </div>
  </div>
  } }
</div>
